import React from 'react'
import 'rc-texty/assets/index.css';
import { getEnter } from '@/utils'
import { Button, Modal } from 'antd';
import baseReport1 from "@/assets/img/report-page/base-report1.png";
import baseReport2 from "@/assets/img/report-page/base-report2.png";
import baseReport3 from "@/assets/img/report-page/base-report3.png";
import baseReport4 from "@/assets/img/report-page/base-report4.png";
import baseReport5 from "@/assets/img/report-page/base-report5.png";
import baseReport6 from "@/assets/img/report-page/base-report6.png";
import baseReport7 from "@/assets/img/report-page/base-report7.png";
import baseReport8 from "@/assets/img/report-page/base-report8.png";
import baseReport9 from "@/assets/img/report-page/base-report9.png";
import baseReport10 from "@/assets/img/report-page/base-report10.png";
import baseReport11 from "@/assets/img/report-page/base-report11.png";
import baseReport12 from "@/assets/img/report-page/base-report12.png";
import baseReport13 from "@/assets/img/report-page/base-report13.png";
import baseReport14 from "@/assets/img/report-page/base-report14.png";
import baseReport15 from "@/assets/img/report-page/base-report15.png";
import baseReport16 from "@/assets/img/report-page/base-report16.png";
import baseReport17 from "@/assets/img/report-page/base-report17.png";
import baseReport18 from "@/assets/img/report-page/base-report18.png";
import baseReport19 from "@/assets/img/report-page/base-report19.png";
import baseReport20 from "@/assets/img/report-page/base-report20.png";
import baseReport21 from "@/assets/img/report-page/base-report21.png";
import baseReport22 from "@/assets/img/report-page/base-report22.png";
import "./index.less";
const BaseDetailModal = (props) => {
	const { closeModal } = props || {};
  return (
		<>
			<Modal width='90vw' className="report-modal" title="企业信用报告-基础版" open footer={null} onCancel={closeModal}>
        <div className='report-content'>
					<img className='report-img' src={baseReport1} />
					<img className='report-img' src={baseReport2} />
					<img className='report-img' src={baseReport3} />
					<img className='report-img' src={baseReport4} />
					<img className='report-img' src={baseReport5} />
					<img className='report-img' src={baseReport6} />
					<img className='report-img' src={baseReport7} />
					<img className='report-img' src={baseReport8} />
					<img className='report-img' src={baseReport9} />
					<img className='report-img' src={baseReport10} />
					<img className='report-img' src={baseReport11} />
					<img className='report-img' src={baseReport12} />
					<img className='report-img' src={baseReport13} />
					<img className='report-img' src={baseReport14} />
					<img className='report-img' src={baseReport15} />
					<img className='report-img' src={baseReport16} />
					<img className='report-img' src={baseReport17} />
					<img className='report-img' src={baseReport18} />
					<img className='report-img' src={baseReport19} />
					<img className='report-img' src={baseReport20} />
					<img className='report-img' src={baseReport21} />
					<img className='report-img' src={baseReport22} />
				</div>
				<div className='report-footer'>
					<Button onClick={closeModal}>关闭</Button>
				</div>
      </Modal>
		</>
  )
}

export default BaseDetailModal;
